import { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import FormHelperText from '@mui/material/FormHelperText';
//
import Editor, { EditorProps } from '../editor';
// ----------------------------------------------------------------------
// interface Props extends EditorProps {
//   name: string;
//   onUpdateContent: (content: string) => void;
// }
// export default function RHFEditor({ name, helperText, ...other }: Props) {
//   const {
//     control,
//     watch,
//     setValue,
//     formState: { isSubmitSuccessful },
//   } = useFormContext();
//   const values = watch();
//   useEffect(() => {
//     if (values[name] === '<p><br></p>') {
//       setValue(name, '', {
//         shouldValidate: !isSubmitSuccessful,
//       });
//     }
//   }, [isSubmitSuccessful, name, setValue, values]);
//   return (
//     <Controller
//     name={name}
//     control={control}
//     render={({ field, fieldState: { error } }) => (
//       <div>
//         <Editor
//           id={name}
//           value={field.value}
//           onChange={(value) => {
//             console.log(value);
//             field.onChange(value);
//           }}
//           error={!!error}
//           helperText={
//             (!!error || helperText) && (
//               <FormHelperText error={!!error} sx={{ px: 2 }}>
//                 {error ? error?.message : helperText}
//               </FormHelperText>
//             )
//           }
//           {...other}
//         />
//         {/* Display HTML content as React content */}
//         <div dangerouslySetInnerHTML={{ __html: field.value }} />
//       </div>
//     )}
//   />
//   );
// }
// RHFEditor component

// ... (imports)

interface RHFEditorProps extends EditorProps {
  name: string;
  onUpdateContent: (content: string) => void;
}

export default function RHFEditor({ name, helperText, onUpdateContent, ...other }: RHFEditorProps) {
  const {
    control,
    watch,
    setValue,
    formState: { isSubmitSuccessful },
  } = useFormContext();
  const values = watch();

  useEffect(() => {
    if (values[name] === '<p><br></p>') {
      setValue(name, '', {
        shouldValidate: !isSubmitSuccessful,
      });
    }
  }, [isSubmitSuccessful, name, setValue, values]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <Editor
            id={name}
            value={field.value}
            onChange={(value) => {
              field.onChange(value);
              // Pass the updated content to the parent component
              onUpdateContent(value);
            }}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2 }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            {...other}
          />
          {/* Display HTML content as React content */}
          {/* <div dangerouslySetInnerHTML={{ __html: field.value }} /> */}
        </div>
      )}
    />
  );
}









